import { ImageStyle, StyleProp, StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';
import type { StylesMap } from 'types';
import { Device } from 'DeviceUtils';

const iconSize = Device.isTablet ? Theme.BU * 4.8 : Theme.BU * 3.5;
const channelIconLine = Theme.BU * 1.4;
const containerPaddingleft = Device.isTablet ? 70 : 35;
const containerPaddingBottom = Device.isTablet ? 50 : 15;
const infoContainerWidth = 600;
const infoContainerHeight = Device.isTabletOrWeb ? 155 : 102;
const imageHeight = Device.isTabletOrWeb ? 148 : 94;
const imageWidth = Device.isTabletOrWeb ? 260 : 168;

const baseStyles: StylesMap = {
    container: {
        // position: 'relative',
        // flex: 1,
        // width: '100%',
        // height: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        overflow: 'visible'
    },
    innerContainer: {
        // alignItems: 'flex-start',
        // flexDirection: 'column',
        // justifyContent: 'flex-end',
        // height: '100%',
        // width: '100%',
        paddingLeft: containerPaddingleft,
        paddingBottom: containerPaddingBottom
    },
    countdownCircle: { alignSelf: 'center' },
    epgIcon: {
        position: 'absolute',
        top: '3%',
        right: '3%'
    },
    backgroundContainer: {
        height: 100
    },
    nextItemImage: {
        flexDirection: 'column'
    },
    itemImageContainer: {
        width: imageWidth,
        height: imageHeight,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'grey'
    },
    nextItemContainer: {
        alignItems: 'flex-end',
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    itemImageBackground: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        borderWidth: 0.5,
        borderStyle: 'solid',
        borderColor: 'grey',
        backgroundColor: 'black'
    },
    itemInfoContainer: {
        width: infoContainerWidth,
        height: infoContainerHeight,
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'column',
        paddingLeft: 20
    },
    iteminfoContainerEpisode: {
        width: infoContainerWidth,
        height: infoContainerHeight,
        paddingLeft: 20,
        justifyContent: 'flex-end'
    },
    channelInfoContainer: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'flex-start'
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    upNextTitle: {
        ...fontStyles.heading2,
        fontSize: 20,
        textTransform: 'uppercase',
        marginBottom: Device.isTablet ? 7 : 8
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    nextItemTitle: {
        ...fontStyles.heading2,
        fontSize: 30,
        height: 'auto'
    },
    nextItemDetail: {
        ...fontStyles.secondaryText,
        marginBottom: 0,
        fontSize: 20
    },
    channelIconStyle: {
        width: 50,
        height: 50,
        // marginTop: -20,
        marginBottom: 5
    },
    nextItemChannelName: {
        ...fontStyles.secondaryText,
        fontSize: 20,
        marginLeft: 10
    },
    channelIconLine: {
        width: channelIconLine,
        borderBottomWidth: 2,
        borderBottomColor: 'white',
        borderStyle: 'solid',
        marginBottom: 5
    },
    gradient: {
        flex: 1,
        height: '150%'
    }
};

export const imageStyle: StyleProp<ImageStyle> = {
    opacity: 0.5
};

export default StyleSheet.create(baseStyles as any);
